import { Tag, Flex } from "@chakra-ui/react";
import moment from "moment";
import { useMemo } from "react";
import { ColumnsType } from "antd/es/table/interface";

function usePerfilListagemColumns() {
  return useMemo((): ColumnsType => {
    return [
      {
        title: "Perfil",
        render: (item: any) => {
          return (
            <Flex flex={1} gap="16px">
              <Flex>{item.nome}</Flex>
              {item.admin ? <Tag colorScheme={"blue"}>Admin</Tag> : null}
            </Flex>
          );
        },
      },
      {
        title: "Tempo de Acesso",
        render: (item: any) => {
          if (
            moment(moment(item.dataFim).format("YYYY-MM-DD")).isBefore(
              moment().format("YYYY-MM-DD")
            )
          ) {
            const daysExpired = moment(moment()).diff(item.dataFim, "days");

            return (
              <Tag colorScheme={"red"}>
                Perfil expirado há {daysExpired}{" "}
                {daysExpired === 1 ? "dia" : "dias"}
              </Tag>
            );
          }

          const days = moment(item.dataFim).diff(item.dataInicio, "days");

          if (isNaN(days)) {
            return "---";
          }

          if (days === 1) {
            return (
              <>
                Resta <strong>1</strong> dia de acesso
              </>
            );
          }

          return (
            <>
              Restam <strong>{days}</strong> dias de acesso
            </>
          );
        },
      },
    ];
  }, []);
}

export default usePerfilListagemColumns;
